import { Link } from "react-router-dom";
import {ReactComponent as ErrorImg}  from "../assets/images/ErrorPage.svg"

const ErrorFallback = ({ error, resetErrorBoundary }) => (
    <div className=" w-full h-screen flex flex-col justify-center items-center gap-y-3">
      <div className=" w-[300px] h-[300px] 2xl:w-[425px] 2xl:h-[425px]">
      <ErrorImg/>
      </div>
     
      <p className=" text-xl 2xl:text-2xl font-medium">Something went wrong</p>
      <div className=" flex justify-center items-center gap-5">
      <button onClick={resetErrorBoundary} className=" bg-primary text-white  text-sm py-1 px-3 rounded-md 2xl:text-base font-medium">Try again</button>
      <Link to={`/main/standard`}><button  className=" bg-primary text-white  text-sm py-1 px-3 rounded-md 2xl:text-base font-medium">Home</button></Link> 
      </div> 
    </div>
  );

  export default ErrorFallback;